mutation SetStreamsReviewerAccess($email: String!, $enabled: Boolean!) {
  result: StreamToolsSetStreamsReviewerAccess(email: $email, enabled: $enabled) {
    accountId
    streamsReviewerAccess
    previousValue
  }
}
